module.exports = __webpack_public_path__ + "img/right7.e8a8adec.png";